import { PopulatedItemClient } from '../clients/PopulatedItemClient/PopulatedItemClient';
import { PopulatedModifierGroupClient } from '../clients/PopulatedModifierGroupClient/PopulatedModifierGroupClient';
const createRequestFunction = params => {
  const request = async (ambassadorFn, fnParams) => {
    const shouldSendSignedInstance = ('signedInstance' in params);
    if (shouldSendSignedInstance) {
      if (params.withErrorHandler) {
        try {
          const result = await params.withErrorHandler(() => params.httpClient.request(ambassadorFn(fnParams), {
            signedInstance: params.signedInstance
          }), {
            errorCodesMap: {}
          });
          return result;
        } catch (e) {
          params.getResolvedError && params.getResolvedError(e);
          throw e;
        }
      } else {
        return params.httpClient.request(ambassadorFn(fnParams), {
          signedInstance: params.signedInstance
        });
      }
    }
    if (params.withErrorHandler) {
      try {
        const result = await params.withErrorHandler(() => params.httpClient.request(ambassadorFn(fnParams)), {
          errorCodesMap: {}
        });
        return result;
      } catch (e) {
        params.getResolvedError && params.getResolvedError(e);
        throw e;
      }
    }
    return params.httpClient.request(ambassadorFn(fnParams));
  };
  return request;
};
export const createPopulatedItemClientFactory = params => {
  const request = createRequestFunction(params);
  return new PopulatedItemClient({
    request,
    populationLevel: params.populationLevel
  });
};
export const createPopulatedModifierGroupClientFactory = params => {
  const request = createRequestFunction(params);
  return new PopulatedModifierGroupClient({
    request,
    populationLevel: params.populationLevel
  });
};
//# sourceMappingURL=factoryCreator.js.map